var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "11px",
    viewBox: "0 0 11 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Weeralarm",
    transform: "translate(-201.000000, -60.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M204.928571,60 L204.928571,60.7857143 L201.785714,60.7857143 L201.785714,70.2142857 L211.214286,70.2142857 L211.214286,67.0714286 L212,67.0714286 L212,70.2142857 L212,70.2142857 L212,71 L201.785714,71 L201.785714,71 L201,71 L201,60 L204.928571,60 Z M212,60 L212,65.3035714 L210.232143,63.5357143 L206.696429,67.0714286 L204.928571,65.3035714 L208.464286,61.7678571 L206.696429,60 L212,60 Z",
    id: "external"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external-link.73f9b540bf2d42a466e9aa6e0dcf636e.svg";
export { ForwardRef as ReactComponent };